/* Généré depuis msb-ui-designsystem/src/commonMain/composeResources/drawable (app MySmartBook). */
export interface IconData { vb: string; paths: Array<{ d: string; fill: string; stroke?: string; sw?: string; round?: boolean }> }

const data = {
 "close": {
  "vb": "0 0 960 960",
  "paths": [
   {
    "d": "M256,746.15L213.85,704L437.85,480L213.85,256L256,213.85L480,437.85L704,213.85L746.15,256L522.15,480L746.15,704L704,746.15L480,522.15L256,746.15Z",
    "fill": "currentColor"
   }
  ]
 },
 "bookmarkAdd": {
  "vb": "0 0 960 960",
  "paths": [
   {
    "d": "M220,810L220,212.31Q220,182 241,161Q262,140 292.31,140L520,140Q520,157.23 520,170Q520,182.77 520,200L292.31,200Q287.69,200 283.85,203.85Q280,207.69 280,212.31L280,718L480,632L680,718L680,440Q697.23,440 710,440Q722.77,440 740,440L740,810L480,698.46L220,810ZM280,200L280,200Q280,200 283.85,200Q287.69,200 292.31,200L520,200Q520,200 520,200Q520,200 520,200Q520,200 520,200Q520,200 520,200L520,200L480,200L280,200ZM680,360L680,280L600,280L600,220L680,220L680,140L740,140L740,220L820,220L820,280L740,280L740,360L680,360Z",
    "fill": "currentColor"
   }
  ]
 },
 "bookmark": {
  "vb": "0 0 960 960",
  "paths": [
   {
    "d": "M220,810L220,212.31Q220,182 241,161Q262,140 292.31,140L667.69,140Q698,140 719,161Q740,182 740,212.31L740,810L480,698.46L220,810Z",
    "fill": "currentColor"
   }
  ]
 },
 "bookmarks": {
  "vb": "0 0 960 960",
  "paths": [
   {
    "d": "M180,860L180,329.23Q180,299.31 201.19,278.12Q222.39,256.92 252.31,256.92L553.46,256.92Q583.38,256.92 604.58,278.12Q625.77,299.31 625.77,329.23L625.77,860L403.08,746.92L180,860ZM240,767.46L403.08,681.08L565.77,767.46L565.77,329.23Q565.77,323.85 562.31,320.38Q558.85,316.92 553.46,316.92L252.31,316.92Q246.92,316.92 243.46,320.38Q240,323.85 240,329.23L240,767.46ZM720,708.85L720,172.31Q720,166.92 716.54,163.46Q713.08,160 707.69,160L295.77,160L295.77,100L707.69,100Q737.61,100 758.81,121.19Q780,142.39 780,172.31L780,708.85L720,708.85ZM240,316.92L240,316.92Q240,316.92 243.46,316.92Q246.92,316.92 252.31,316.92L553.46,316.92Q558.85,316.92 562.31,316.92Q565.77,316.92 565.77,316.92L565.77,316.92L403.08,316.92L240,316.92Z",
    "fill": "currentColor"
   }
  ]
 },
 "contents": {
  "vb": "0 0 960 960",
  "paths": [
   {
    "d": "M293.08,362.31L293.08,302.31L820,302.31L820,362.31L293.08,362.31ZM293.08,510L293.08,450L820,450L820,510L293.08,510ZM293.08,657.69L293.08,597.69L820,597.69L820,657.69L293.08,657.69ZM172.31,364.62Q158.58,364.62 149.29,355.22Q140,345.82 140,331.92Q140,318.36 149.29,309.18Q158.58,300 172.31,300Q186.04,300 195.33,309.18Q204.62,318.36 204.62,331.92Q204.62,345.82 195.33,355.22Q186.04,364.62 172.31,364.62ZM172.31,511.92Q158.58,511.92 149.29,502.74Q140,493.57 140,480Q140,465.69 149.29,456.5Q158.58,447.31 172.31,447.31Q186.04,447.31 195.33,456.5Q204.62,465.69 204.62,480Q204.62,493.57 195.33,502.74Q186.04,511.92 172.31,511.92ZM172.31,660Q158.58,660 149.29,650.6Q140,641.2 140,627.31Q140,613.74 149.29,604.56Q158.58,595.38 172.31,595.38Q186.04,595.38 195.33,604.56Q204.62,613.74 204.62,627.31Q204.62,641.2 195.33,650.6Q186.04,660 172.31,660Z",
    "fill": "currentColor"
   }
  ]
 },
 "preferences": {
  "vb": "0 0 960 960",
  "paths": [
   {
    "d": "M146.77,697.23L304.46,272.62L365.77,272.62L524.61,697.23L464.38,697.23L424.23,582.15L246.62,582.15L206.23,697.23L146.77,697.23ZM265,532L405.62,532L336.62,336.54L333.38,336.54L265,532ZM655.38,706.85Q606.69,706.85 577.65,680.31Q548.61,653.77 548.61,611.85Q548.61,568.61 582.54,541.46Q616.46,514.31 669.69,514.31Q691.92,514.31 713.92,518.5Q735.92,522.69 752.31,530.08L752.31,512.31Q752.31,478.31 732.19,459.15Q712.08,440 676.15,440Q654.31,440 635.88,448.34Q617.46,456.69 601.54,473.15L565.31,444.31Q588.54,419.54 615.77,407.85Q643,396.15 676.77,396.15Q740,396.15 770.92,427.11Q801.84,458.08 801.84,520L801.84,697.23L752.31,697.23L752.31,658.31L748.31,658.31Q733.54,682.46 709.73,694.65Q685.92,706.85 655.38,706.85ZM662.77,663.62Q703.15,663.62 728.04,636.92Q752.92,610.23 752.92,572.08Q738.92,564.08 718.46,559.58Q698,555.08 678.23,555.08Q642.38,555.08 621.69,570.23Q601,585.38 601,611.85Q601,634.15 618.34,648.88Q635.69,663.62 662.77,663.62Z",
    "fill": "currentColor"
   }
  ]
 },
 "chat": {
  "vb": "0 0 25 16",
  "paths": [
   {
    "d": "M16.075,15.978C15.719,15.978 15.363,15.844 15.088,15.61C12.655,13.439 9.51,12.237 6.227,12.237C4.46,12.237 2.83,11.535 1.636,10.277C0.443,9.008 -0.143,7.271 0.03,5.523C0.328,2.427 3.197,0 6.549,0H18.451C21.802,0 24.66,2.427 24.97,5.523C25.142,7.271 24.568,8.952 23.363,10.244C22.17,11.513 20.471,12.248 18.692,12.248H17.957C17.728,12.248 17.533,12.437 17.533,12.66V14.597C17.533,15.154 17.2,15.655 16.672,15.877C16.488,15.955 16.293,16 16.098,16L16.075,15.978ZM6.549,1.659C4.07,1.659 1.969,3.418 1.751,5.679C1.625,6.981 2.038,8.217 2.922,9.152C3.783,10.065 4.953,10.566 6.239,10.566C9.751,10.566 13.125,11.769 15.811,13.985V12.649C15.811,11.502 16.775,10.566 17.957,10.566H18.692C19.977,10.566 21.217,10.032 22.089,9.108C22.973,8.173 23.386,6.948 23.26,5.679C23.042,3.429 20.93,1.67 18.462,1.67H6.549V1.659Z",
    "fill": "currentColor"
   }
  ]
 },
 "send": {
  "vb": "0 0 960 960",
  "paths": [
   {
    "d": "M450,780L450,294.92L222.15,522.77L180,480L480,180L780,480L737.85,522.77L510,294.92L510,780L450,780Z",
    "fill": "currentColor"
   }
  ]
 },
 "thumbUp": {
  "vb": "0 0 960 960",
  "paths": [
   {
    "d": "M709.23,820L288.46,820L288.46,340L553.85,76.16L587.69,110Q593.92,116.23 598.04,126.5Q602.15,136.77 602.15,145.85L602.15,156L559.69,340L827.69,340Q856.23,340 878.11,361.89Q900,383.77 900,412.31L900,476.92Q900,483.15 898.38,490.38Q896.77,497.61 894.77,503.85L780.15,774.31Q771.54,793.54 751.31,806.77Q731.08,820 709.23,820ZM348.46,760L709.23,760Q713.46,760 717.88,757.69Q722.31,755.38 724.62,750L840,480L840,412.31Q840,406.92 836.54,403.46Q833.08,400 827.69,400L483.85,400L534,180.77L348.46,365.54L348.46,760ZM348.46,365.54L348.46,365.54L348.46,400L348.46,400Q348.46,400 348.46,403.46Q348.46,406.92 348.46,412.31L348.46,480L348.46,750Q348.46,755.38 348.46,757.69Q348.46,760 348.46,760L348.46,760L348.46,365.54ZM288.46,340L288.46,400L160,400L160,760L288.46,760L288.46,820L100,820L100,340L288.46,340Z",
    "fill": "currentColor"
   }
  ]
 },
 "thumbUpFilled": {
  "vb": "0 0 960 960",
  "paths": [
   {
    "d": "M709.23,820L313.08,820L313.08,340L578.46,76.16L612.3,110Q618.54,116.23 622.65,126.5Q626.77,136.77 626.77,145.85L626.77,156L584.3,340L827.69,340Q856.23,340 878.11,361.89Q900,383.77 900,412.31L900,476.92Q900,483.15 898.69,490.38Q897.38,497.61 894.77,503.85L780.15,774.31Q771.54,793.54 751.31,806.77Q731.08,820 709.23,820ZM253.08,340L253.08,820L100,820L100,340L253.08,340Z",
    "fill": "currentColor"
   }
  ]
 },
 "thumbDown": {
  "vb": "0 0 960 960",
  "paths": [
   {
    "d": "M250.77,156.16L671.54,156.16L671.54,636.15L406.15,900L372.31,866.15Q366.08,859.92 361.96,849.65Q357.85,839.38 357.85,830.31L357.85,820.15L400.31,636.15L132.31,636.15Q103.77,636.15 81.89,614.27Q60,592.38 60,563.85L60,499.23Q60,493 61.62,485.77Q63.23,478.54 65.23,472.31L179.85,201.85Q188.46,182.62 208.69,169.39Q228.92,156.16 250.77,156.16ZM611.54,216.16L250.77,216.16Q246.54,216.16 242.12,218.46Q237.69,220.77 235.38,226.16L120,496.16L120,563.85Q120,569.23 123.46,572.69Q126.92,576.16 132.31,576.16L476.15,576.16L426,795.39L611.54,610.62L611.54,216.16ZM611.54,610.62L611.54,610.62L611.54,576.16L611.54,576.16Q611.54,576.16 611.54,572.69Q611.54,569.23 611.54,563.85L611.54,496.16L611.54,226.16Q611.54,220.77 611.54,218.46Q611.54,216.16 611.54,216.16L611.54,216.16L611.54,610.62ZM671.54,636.15L671.54,576.16L800,576.16L800,216.16L671.54,216.16L671.54,156.16L860,156.16L860,636.15L671.54,636.15Z",
    "fill": "currentColor"
   }
  ]
 },
 "thumbDownFilled": {
  "vb": "0 0 960 960",
  "paths": [
   {
    "d": "M250.77,156.16L646.92,156.16L646.92,636.15L381.54,900L347.7,866.15Q341.46,859.92 337.35,849.65Q333.23,839.38 333.23,830.31L333.23,820.15L375.7,636.15L132.31,636.15Q103.77,636.15 81.89,614.27Q60,592.38 60,563.85L60,499.23Q60,493 61.31,485.77Q62.62,478.54 65.23,472.31L179.85,201.85Q188.46,182.62 208.69,169.39Q228.92,156.16 250.77,156.16ZM706.92,636.15L706.92,156.16L860,156.16L860,636.15L706.92,636.15Z",
    "fill": "currentColor"
   }
  ]
 },
 "add": {
  "vb": "0 0 960 960",
  "paths": [
   {
    "d": "M450,510L220,510L220,450L450,450L450,220L510,220L510,450L740,450L740,510L510,510L510,740L450,740L450,510Z",
    "fill": "currentColor"
   }
  ]
 },
 "remove": {
  "vb": "0 0 960 960",
  "paths": [
   {
    "d": "M220,510L220,450L740,450L740,510L220,510Z",
    "fill": "currentColor"
   }
  ]
 },
 "columnsAuto": {
  "vb": "0 0 960 960",
  "paths": [
   {
    "d": "M800,360L800,252.31Q800,247.69 796.15,243.85Q792.31,240 787.69,240L680,240L680,180L787.69,180Q818,180 839,201Q860,222 860,252.31L860,360L800,360ZM100,360L100,252.31Q100,222 121,201Q142,180 172.31,180L280,180L280,240L172.31,240Q167.69,240 163.85,243.85Q160,247.69 160,252.31L160,360L100,360ZM680,780L680,720L787.69,720Q792.31,720 796.15,716.15Q800,712.31 800,707.69L800,600L860,600L860,707.69Q860,738 839,759Q818,780 787.69,780L680,780ZM172.31,780Q142,780 121,759Q100,738 100,707.69L100,600L160,600L160,707.69Q160,712.31 163.85,716.15Q167.69,720 172.31,720L280,720L280,780L172.31,780ZM256.92,623.08L256.92,336.92L703.08,336.92L703.08,623.08L256.92,623.08ZM316.92,563.08L643.08,563.08L643.08,396.92L316.92,396.92L316.92,563.08ZM316.92,563.08L316.92,396.92L316.92,396.92L316.92,563.08Z",
    "fill": "currentColor"
   }
  ]
 },
 "columnsOne": {
  "vb": "0 0 38 17",
  "paths": [
   {
    "d": "M0,1L38,1",
    "fill": "none",
    "stroke": "currentColor",
    "sw": "2"
   },
   {
    "d": "M0,6L38,6",
    "fill": "none",
    "stroke": "currentColor",
    "sw": "2"
   },
   {
    "d": "M0,11L38,11",
    "fill": "none",
    "stroke": "currentColor",
    "sw": "2"
   },
   {
    "d": "M0,16L38,16",
    "fill": "none",
    "stroke": "currentColor",
    "sw": "2"
   }
  ]
 },
 "columnsTwo": {
  "vb": "0 0 38 17",
  "paths": [
   {
    "d": "M0,1L15.907,1",
    "fill": "none",
    "stroke": "currentColor",
    "sw": "2"
   },
   {
    "d": "M22.093,1L38,1",
    "fill": "none",
    "stroke": "currentColor",
    "sw": "2"
   },
   {
    "d": "M0,6L15.907,6",
    "fill": "none",
    "stroke": "currentColor",
    "sw": "2"
   },
   {
    "d": "M22.093,6L38,6",
    "fill": "none",
    "stroke": "currentColor",
    "sw": "2"
   },
   {
    "d": "M0,11L15.907,11",
    "fill": "none",
    "stroke": "currentColor",
    "sw": "2"
   },
   {
    "d": "M22.093,11L38,11",
    "fill": "none",
    "stroke": "currentColor",
    "sw": "2"
   },
   {
    "d": "M0,16L15.907,16",
    "fill": "none",
    "stroke": "currentColor",
    "sw": "2"
   },
   {
    "d": "M22.093,16L38,16",
    "fill": "none",
    "stroke": "currentColor",
    "sw": "2"
   }
  ]
 },
 "themeSystem": {
  "vb": "0 0 960 960",
  "paths": [
   {
    "d": "M480,480m-400,0a400,400 0,1 1,800 0a400,400 0,1 1,-800 0",
    "fill": "#000000"
   },
   {
    "d": "M480,80A400,400 0,0 1,880 480,400 400,0 0,1 480,880L480,480Z",
    "fill": "#ffffff"
   }
  ]
 },
 "themeLight": {
  "vb": "0 0 960 960",
  "paths": [
   {
    "d": "M480,480m-400,0a400,400 0,1 1,800 0a400,400 0,1 1,-800 0",
    "fill": "#ffffff"
   }
  ]
 },
 "themeDark": {
  "vb": "0 0 960 960",
  "paths": [
   {
    "d": "M480,480m-400,0a400,400 0,1 1,800 0a400,400 0,1 1,-800 0",
    "fill": "#000000"
   }
  ]
 },
 "themeSepia": {
  "vb": "0 0 960 960",
  "paths": [
   {
    "d": "M480,480m-400,0a400,400 0,1 1,800 0a400,400 0,1 1,-800 0",
    "fill": "#faf4e8",
    "stroke": "#DFC0B7",
    "sw": "42.5498"
   }
  ]
 },
 "alignJustify": {
  "vb": "0 0 38 17",
  "paths": [
   {
    "d": "M0,1L38,1",
    "fill": "none",
    "stroke": "currentColor",
    "sw": "2"
   },
   {
    "d": "M0,6L38,6",
    "fill": "none",
    "stroke": "currentColor",
    "sw": "2"
   },
   {
    "d": "M0,11L38,11",
    "fill": "none",
    "stroke": "currentColor",
    "sw": "2"
   },
   {
    "d": "M0,16L38,16",
    "fill": "none",
    "stroke": "currentColor",
    "sw": "2"
   }
  ]
 },
 "alignLeft": {
  "vb": "0 0 36 17",
  "paths": [
   {
    "d": "M0,1L36,1",
    "fill": "none",
    "stroke": "currentColor",
    "sw": "2"
   },
   {
    "d": "M0,6L32,6",
    "fill": "none",
    "stroke": "currentColor",
    "sw": "2"
   },
   {
    "d": "M0,11L28,11",
    "fill": "none",
    "stroke": "currentColor",
    "sw": "2"
   },
   {
    "d": "M0,16L35,16",
    "fill": "none",
    "stroke": "currentColor",
    "sw": "2"
   }
  ]
 },
 "alignRight": {
  "vb": "0 0 36 17",
  "paths": [
   {
    "d": "M0,1L36,1",
    "fill": "none",
    "stroke": "currentColor",
    "sw": "2"
   },
   {
    "d": "M4,6L36,6",
    "fill": "none",
    "stroke": "currentColor",
    "sw": "2"
   },
   {
    "d": "M8,11L36,11",
    "fill": "none",
    "stroke": "currentColor",
    "sw": "2"
   },
   {
    "d": "M1,16L36,16",
    "fill": "none",
    "stroke": "currentColor",
    "sw": "2"
   }
  ]
 },
 "lineSmall": {
  "vb": "0 0 38 17",
  "paths": [
   {
    "d": "M0,16L38,16",
    "fill": "none",
    "stroke": "currentColor",
    "sw": "2"
   },
   {
    "d": "M0,1L38,1",
    "fill": "none",
    "stroke": "currentColor",
    "sw": "2"
   },
   {
    "d": "M0,4.747L38,4.747",
    "fill": "none",
    "stroke": "currentColor",
    "sw": "2"
   },
   {
    "d": "M0,8.494L38,8.494",
    "fill": "none",
    "stroke": "currentColor",
    "sw": "2"
   },
   {
    "d": "M0,12.241L38,12.241",
    "fill": "none",
    "stroke": "currentColor",
    "sw": "2"
   }
  ]
 },
 "lineMedium": {
  "vb": "0 0 40 17",
  "paths": [
   {
    "d": "M0,1L40,1",
    "fill": "none",
    "stroke": "currentColor",
    "sw": "2"
   },
   {
    "d": "M0,6L40,6",
    "fill": "none",
    "stroke": "currentColor",
    "sw": "2"
   },
   {
    "d": "M0,11L40,11",
    "fill": "none",
    "stroke": "currentColor",
    "sw": "2"
   },
   {
    "d": "M0,16L40,16",
    "fill": "none",
    "stroke": "currentColor",
    "sw": "2"
   }
  ]
 },
 "lineLarge": {
  "vb": "0 0 38 18",
  "paths": [
   {
    "d": "M0,1L38,1",
    "fill": "none",
    "stroke": "currentColor",
    "sw": "2"
   },
   {
    "d": "M0,9L38,9",
    "fill": "none",
    "stroke": "currentColor",
    "sw": "2"
   },
   {
    "d": "M0,17L38,17",
    "fill": "none",
    "stroke": "currentColor",
    "sw": "2"
   }
  ]
 },
 "reset": {
  "vb": "0 0 960 960",
  "paths": [
   {
    "d": "M479.23,540Q454.69,540 436.96,522.27Q419.23,504.54 419.23,480Q419.23,455.46 436.96,437.73Q454.69,420 479.23,420Q503.77,420 521.5,437.73Q539.23,455.46 539.23,480Q539.23,504.54 521.5,522.27Q503.77,540 479.23,540ZM479.23,820Q348.69,820 252.46,734.27Q156.23,648.54 141.62,520L202.85,520Q218,623.62 296.27,691.81Q374.54,760 479.23,760Q596.23,760 677.73,678.5Q759.23,597 759.23,480Q759.23,363 677.73,281.5Q596.23,200 479.23,200Q413.69,200 356.39,229.12Q299.08,258.23 257.69,309.23L362.31,309.23L362.31,369.23L159.23,369.23L159.23,166.15L219.23,166.15L219.23,260.92Q267.92,203.46 335.85,171.73Q403.77,140 479.23,140Q550.03,140 611.86,166.77Q673.69,193.54 719.69,239.54Q765.69,285.54 792.46,347.36Q819.23,409.19 819.23,479.98Q819.23,550.77 792.46,612.61Q765.69,674.46 719.69,720.46Q673.69,766.46 611.86,793.23Q550.03,820 479.23,820Z",
    "fill": "currentColor"
   }
  ]
 },
 "delete": {
  "vb": "0 0 960 960",
  "paths": [
   {
    "d": "M292.31,820Q262.39,820 241.19,798.81Q220,777.61 220,747.69L220,240L180,240L180,180L360,180L360,144.62L600,144.62L600,180L780,180L780,240L740,240L740,747.69Q740,778 719,799Q698,820 667.69,820L292.31,820ZM680,240L280,240L280,747.69Q280,753.08 283.46,756.54Q286.92,760 292.31,760L667.69,760Q672.31,760 676.15,756.15Q680,752.31 680,747.69L680,240ZM376.16,680L436.15,680L436.15,320L376.16,320L376.16,680ZM523.85,680L583.84,680L583.84,320L523.85,320L523.85,680ZM280,240L280,240L280,747.69Q280,753.08 280,756.54Q280,760 280,760L280,760Q280,760 280,756.54Q280,753.08 280,747.69L280,240Z",
    "fill": "currentColor"
   }
  ]
 },
 "back": {
  "vb": "0 0 960 960",
  "paths": [
   {
    "d": "M640,866.15L253.85,480L640,93.85L696.77,150.62L367.38,480L696.77,809.38L640,866.15Z",
    "fill": "currentColor"
   }
  ]
 },
 "check": {
  "vb": "0 0 960 960",
  "paths": [
   {
    "d": "M382,706.15L168.62,492.77L211.38,450L382,620.62L748.62,254L791.38,296.77L382,706.15Z",
    "fill": "currentColor"
   }
  ]
 },
 "textIncrease": {
  "vb": "0 0 960 960",
  "paths": [
   {
    "d": "M52.31,750L263.08,210L332.31,210L543.08,750L470.92,750L416.46,605.85L177.38,605.85L122.92,750L52.31,750ZM199.08,546L394.77,546L299.57,294L294.92,294L199.08,546ZM727.69,630L727.69,510L607.69,510L607.69,450L727.69,450L727.69,330L787.69,330L787.69,450L907.69,450L907.69,510L787.69,510L787.69,630L727.69,630Z",
    "fill": "currentColor"
   }
  ]
 },
 "textDecrease": {
  "vb": "0 0 960 960",
  "paths": [
   {
    "d": "M52.31,750L263.08,210L332.31,210L543.08,750L470.92,750L416.46,605.85L177.38,605.85L122.92,750L52.31,750ZM199.08,546L394.77,546L299.69,294L294.92,294L199.08,546ZM607.69,510L607.69,450L907.69,450L907.69,510L607.69,510Z",
    "fill": "currentColor"
   }
  ]
 },
 "undo": {"vb": "0 0 960 960", "paths": [{"d": "M288.08,740L288.08,680L575.15,680Q637.77,680 682.92,638.65Q728.08,597.31 728.08,536.54Q728.08,475.77 682.92,434.61Q637.77,393.46 575.15,393.46L294.31,393.46L405.61,504.77L363.46,546.92L180,363.46L363.46,180L405.61,222.15L294.31,333.46L575.15,333.46Q662.92,333.46 725.5,392.04Q788.08,450.62 788.08,536.54Q788.08,622.46 725.5,681.23Q662.92,740 575.15,740L288.08,740Z", "fill": "currentColor"}]},
 "redo": {"vb": "0 0 960 960", "paths": [{"d": "M384.85,740Q297.08,740 234.5,681.23Q171.92,622.46 171.92,536.54Q171.92,450.62 234.5,392.04Q297.08,333.46 384.85,333.46L665.69,333.46L554.39,222.15L596.54,180L780,363.46L596.54,546.92L554.39,504.77L665.69,393.46L384.85,393.46Q322.23,393.46 277.08,434.61Q231.92,475.77 231.92,536.54Q231.92,597.31 277.08,638.65Q322.23,680 384.85,680L671.92,680L671.92,740L384.85,740Z", "fill": "currentColor"}]},
 "chevronRight": {"vb": "0 0 960 960", "paths": [{"d": "M517.85,480L333.85,296L376,253.85L602.15,480L376,706.15L333.85,664L517.85,480Z", "fill": "currentColor"}]},
 "menu": {"vb": "0 -960 960 960", "paths": [{"d": "M120-240v-80h720v80H120Zm0-200v-80h720v80H120Zm0-200v-80h720v80H120Z", "fill": "currentColor"}]},
 "fullscreen": {"vb": "0 -960 960 960", "paths": [{"d": "M120-120v-200h80v120h120v80H120Zm520 0v-80h120v-120h80v200H640ZM120-640v-200h200v80H200v120h-80Zm640 0v-120H640v-80h200v200h-80Z", "fill": "currentColor"}]},
 "ebook": {"vb": "0 0 25 24", "paths": [{"d": "M4.479,0.32H19.535C21.832,0.32 23.693,2.181 23.693,4.476V19.524C23.693,21.819 21.832,23.68 19.535,23.68H4.479C2.182,23.68 0.321,21.819 0.32,19.524V4.476C0.321,2.181 2.182,0.32 4.479,0.32Z", "fill": "none", "stroke": "currentColor", "sw": "1.4"}, {"d": "M12.929,11.538C13.215,11.538 13.448,11.747 13.448,12.005C13.448,12.263 13.215,12.472 12.929,12.472L3.4,12.447C3.114,12.447 2.882,12.237 2.882,11.979C2.882,11.721 3.114,11.512 3.4,11.512L12.929,11.538Z", "fill": "currentColor"}, {"d": "M15.582,16.555C15.862,16.555 16.089,16.76 16.089,17.014C16.089,17.267 15.862,17.473 15.582,17.473L3.389,17.515C3.109,17.515 2.882,17.31 2.882,17.056C2.882,16.803 3.109,16.598 3.389,16.598L15.582,16.555Z", "fill": "currentColor"}, {"d": "M20.382,6.484C20.67,6.484 20.902,6.695 20.902,6.956C20.902,7.218 20.67,7.43 20.382,7.43H3.402C3.114,7.43 2.882,7.218 2.882,6.956C2.882,6.695 3.115,6.484 3.402,6.484H20.382Z", "fill": "currentColor"}]},
 "smartbook": {"vb": "0 0 24 24", "paths": [{"d": "M4.476,0.382H19.524C21.79,0.382 23.625,2.217 23.625,4.48V19.52C23.625,21.783 21.79,23.618 19.524,23.618H4.476C2.21,23.618 0.375,21.783 0.375,19.52V4.48C0.375,2.217 2.21,0.382 4.476,0.382Z", "fill": "none", "stroke": "currentColor", "sw": "1.4"}, {"d": "M20.359,5.76C20.646,5.76 20.878,5.971 20.878,6.233C20.878,6.494 20.646,6.706 20.359,6.706H3.398C3.111,6.706 2.878,6.494 2.878,6.233C2.879,5.971 3.111,5.76 3.398,5.76H20.359Z", "fill": "currentColor"}, {"d": "M7.194,10.852C6.355,11.076 5.995,11.397 5.758,11.8H3.552C3.291,11.8 3.079,11.588 3.079,11.326C3.079,11.064 3.291,10.852 3.552,10.852L7.194,10.852Z", "fill": "currentColor"}, {"d": "M4.915,15.873H3.552C3.291,15.874 3.079,16.086 3.079,16.348C3.079,16.609 3.291,16.822 3.552,16.822H5.404C5.404,16.822 4.928,16.272 4.915,15.873Z", "fill": "currentColor"}, {"d": "M15.591,20.863C15.376,20.863 15.161,20.778 14.995,20.631C13.524,19.263 11.623,18.506 9.639,18.506C8.571,18.506 7.585,18.064 6.864,17.271C6.142,16.472 5.789,15.377 5.893,14.276C6.073,12.326 7.807,10.797 9.833,10.797H17.027C19.053,10.797 20.781,12.326 20.968,14.276C21.072,15.377 20.725,16.436 19.997,17.25C19.275,18.05 18.248,18.513 17.173,18.513H16.729C16.59,18.513 16.472,18.632 16.472,18.772V19.993C16.472,20.344 16.271,20.659 15.952,20.799C15.841,20.849 15.723,20.877 15.605,20.877L15.591,20.863ZM9.833,11.842C8.335,11.842 7.065,12.95 6.933,14.374C6.857,15.195 7.107,15.973 7.641,16.563C8.161,17.138 8.869,17.454 9.646,17.454C11.769,17.454 13.808,18.211 15.432,19.607V18.765C15.432,18.043 16.014,17.454 16.729,17.454H17.173C17.95,17.454 18.699,17.117 19.227,16.535C19.761,15.945 20.01,15.174 19.934,14.374C19.802,12.957 18.526,11.849 17.034,11.849H9.833V11.842Z", "fill": "currentColor"}]},
 "search": {"vb": "0 -960 960 960", "paths": [{"d": "M784-120 532-372q-30 24-69 38t-83 14q-109 0-184.5-75.5T120-580q0-109 75.5-184.5T380-840q109 0 184.5 75.5T640-580q0 44-14 83t-38 69l252 252-56 56ZM380-400q75 0 127.5-52.5T560-580q0-75-52.5-127.5T380-760q-75 0-127.5 52.5T200-580q0 75 52.5 127.5T380-400Z", "fill": "currentColor"}]},
 "phone": {"vb": "0 -960 960 960", "paths": [{"d": "M280-40q-33 0-56.5-23.5T200-120v-720q0-33 23.5-56.5T280-920h400q33 0 56.5 23.5T760-840v720q0 33-23.5 56.5T680-40H280Zm0-120v40h400v-40H280Zm0-80h400v-480H280v480Zm0-560h400v-40H280v40Zm0 0v-40 40Zm0 640v40-40Z", "fill": "currentColor"}]},
 "listView": {"vb": "0 0 960 960", "paths": [{"d": "M293.08,362.31L293.08,302.31L820,302.31L820,362.31L293.08,362.31ZM293.08,510L293.08,450L820,450L820,510L293.08,510ZM293.08,657.69L293.08,597.69L820,597.69L820,657.69L293.08,657.69ZM172.31,364.62Q158.58,364.62 149.29,355.22Q140,345.82 140,331.92Q140,318.36 149.29,309.18Q158.58,300 172.31,300Q186.04,300 195.33,309.18Q204.62,318.36 204.62,331.92Q204.62,345.82 195.33,355.22Q186.04,364.62 172.31,364.62ZM172.31,511.92Q158.58,511.92 149.29,502.74Q140,493.57 140,480Q140,465.69 149.29,456.5Q158.58,447.31 172.31,447.31Q186.04,447.31 195.33,456.5Q204.62,465.69 204.62,480Q204.62,493.57 195.33,502.74Q186.04,511.92 172.31,511.92ZM172.31,660Q158.58,660 149.29,650.6Q140,641.2 140,627.31Q140,613.74 149.29,604.56Q158.58,595.38 172.31,595.38Q186.04,595.38 195.33,604.56Q204.62,613.74 204.62,627.31Q204.62,641.2 195.33,650.6Q186.04,660 172.31,660Z", "fill": "currentColor"}]},
 "gridView": {"vb": "0 -960 960 960", "paths": [{"d": "M120-520v-320h320v320H120Zm0 400v-320h320v320H120Zm400-400v-320h320v320H520Zm0 400v-320h320v320H520ZM200-600h160v-160H200v160Zm400 0h160v-160H600v160Zm0 400h160v-160H600v160Zm-400 0h160v-160H200v160Zm400-400Zm0 240Zm-240 0Zm0-240Z", "fill": "currentColor"}]},
 "logout": {"vb": "0 0 960 960", "paths": [{"d": "M212.31,820Q182,820 161,799Q140,778 140,747.69L140,212.31Q140,182 161,161Q182,140 212.31,140L480.38,140L480.38,200L212.31,200Q207.69,200 203.85,203.85Q200,207.69 200,212.31L200,747.69Q200,752.31 203.85,756.15Q207.69,760 212.31,760L480.38,760L480.38,820L212.31,820ZM649.23,650.77L607.69,607.38L705.08,510L363.85,510L363.85,450L705.08,450L607.69,352.62L649.23,309.23L820,480L649.23,650.77Z", "fill": "currentColor"}]},
 "playArrow": {"vb": "0 0 960 960", "paths": [{"d": "M340,723.84L340,236.16L723.07,480L340,723.84ZM400,480L400,480L400,480ZM400,614L610.77,480L400,346L400,614Z", "fill": "currentColor"}]},
 "stop": {"vb": "0 0 24 24", "paths": [{"d": "M6,6L18,6L18,18L6,18Z", "fill": "currentColor"}]},
 "note": {"vb": "0 0 24 24", "paths": [{"d": "M5 3h14a2 2 0 0 1 2 2v10l-6 6H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2zm0 2v14h8v-4a2 2 0 0 1 2-2h4V5H5zm10 14.2 3.2-3.2H15v3.2zM7 8h10v2H7V8zm0 4h6v2H7v-2z", "fill": "currentColor"}]},
 "bookmarkOutline": {"vb": "0 -960 960 960", "paths": [{"d": "M200-120v-640q0-33 23.5-56.5T280-840h400q33 0 56.5 23.5T760-760v640L480-240 200-120Zm80-122 200-86 200 86v-518H280v518Zm0-518h400-280Z", "fill": "currentColor"}]},
 "skipPrevious": {"vb": "0 0 960 960", "paths": [{"d": "M220,720L220,240L280,240L280,720L220,720ZM740,720L380,480L740,240L740,720Z", "fill": "currentColor"}]},
 "person": {"vb": "0 -960 960 960", "paths": [{"d": "M480-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47ZM160-160v-112q0-34 17.5-62.5T224-378q62-31 126-46.5T480-440q66 0 130 15.5T736-378q29 15 46.5 43.5T800-272v112H160Zm80-80h480v-32q0-11-5.5-20T700-306q-54-27-109-40.5T480-360q-56 0-111 13.5T260-306q-9 5-14.5 14t-5.5 20v32Zm240-320q33 0 56.5-23.5T560-640q0-33-23.5-56.5T480-720q-33 0-56.5 23.5T400-640q0 33 23.5 56.5T480-560Zm0-80Zm0 400Z", "fill": "currentColor"}]},
 "female": {"vb": "0 0 24 24", "paths": [{"d": "M17,9A5,5 0 1,1 7,9A5,5 0 1,1 17,9M12,14L12,21M9,18L15,18", "fill": "none", "stroke": "currentColor", "sw": "2", "round": true}]},
 "male": {"vb": "0 0 24 24", "paths": [{"d": "M15,14A5,5 0 1,1 5,14A5,5 0 1,1 15,14M13.5,10.5L19,5M14,5L19,5L19,10", "fill": "none", "stroke": "currentColor", "sw": "2", "round": true}]},
 "nearMe": {"vb": "0 -960 960 960", "paths": [{"d": "M516-120 402-402 120-516v-56l720-268-268 720h-56Zm26-148 162-436-436 162 196 78 78 196Zm-78-196Z", "fill": "currentColor"}]},
 "translate": {"vb": "0 -960 960 960", "paths": [{"d": "m476-80 182-480h84L924-80h-84l-43-122H603L560-80h-84ZM160-200l-56-56 202-202q-35-35-63.5-80T190-640h84q20 39 40 68t48 58q33-33 68.5-92.5T484-720H40v-80h280v-80h80v80h280v80H564q-21 72-63 148t-83 116l96 98-30 82-122-125-202 201Zm468-72h144l-72-204-72 204Z", "fill": "currentColor"}]},
 "openInNew": {"vb": "0 -960 960 960", "paths": [{"d": "M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h280v80H200v560h560v-280h80v280q0 33-23.5 56.5T760-120H200Zm188-212-56-56 372-372H560v-80h280v280h-80v-144L388-332Z", "fill": "currentColor"}]},
 "help": {"vb": "0 -960 960 960", "paths": [{"d": "M478-240q21 0 35.5-14.5T528-290q0-21-14.5-35.5T478-340q-21 0-35.5 14.5T428-290q0 21 14.5 35.5T478-240Zm-36-154h74q0-33 7.5-52t42.5-52q26-26 41-49.5t15-56.5q0-56-41-86t-97-30q-57 0-92.5 30T342-618l66 26q5-18 22.5-39t53.5-21q32 0 48 17.5t16 38.5q0 20-12 37.5T506-526q-44 39-54 59t-10 73Zm38 314q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z", "fill": "currentColor"}]},
 "more": {"vb": "0 0 960 960", "paths": [{"d": "M480,770.77Q455.25,770.77 437.63,753.14Q420,735.52 420,710.77Q420,686.02 437.63,668.39Q455.25,650.77 480,650.77Q504.75,650.77 522.37,668.39Q540,686.02 540,710.77Q540,735.52 522.37,753.14Q504.75,770.77 480,770.77ZM480,540Q455.25,540 437.63,522.37Q420,504.75 420,480Q420,455.25 437.63,437.63Q455.25,420 480,420Q504.75,420 522.37,437.63Q540,455.25 540,480Q540,504.75 522.37,522.37Q504.75,540 480,540ZM480,309.23Q455.25,309.23 437.63,291.61Q420,273.98 420,249.23Q420,224.48 437.63,206.86Q455.25,189.23 480,189.23Q504.75,189.23 522.37,206.86Q540,224.48 540,249.23Q540,273.98 522.37,291.61Q504.75,309.23 480,309.23Z", "fill": "currentColor"}]}
} satisfies Record<string, IconData>;

export type IconName = keyof typeof data;
export const icons: Record<IconName, IconData> = data;
